module.exports = __webpack_public_path__ + "img/EBIKE_WORLD_FEDERATION_Logo_Weiss.cdbb9e2f.svg";